const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "Que dia vem antes da terça-feira?", answers: ["segunda-feira", "segunda"], image: null },
      { id: "q2", question: "Que dia vem antes da sexta-feira? ", answers: ["quinta-feira", "quinta"], image: null },
      { id: "q3", question: "Que dia vem depois da quarta-feira? ", answers: ["quinta-feira", "quinta"], image: null },
      { id: "q4", question: "Sábado e domingo são os ... ", answers: ["finais de semana", "findi"], image: null },
      { id: "q5", question: "Uma semana é composta de _____ dias ", answers: ["7", "sete"], image: null },
      { id: "q6", question: "Que dia vem antes da terça-feira?", answers: ["segunda-feira", "segunda"], image: null },
      { id: "q7", question: "Que dia vem antes da sexta-feira? ", answers: ["quinta-feira", "quinta"], image: null },
      { id: "q8", question: "Sábado e domingo são os ...", answers: ["finais de semana", "findi"], image: null },
      { id: "q9", question: "Uma semana é composta de _____ dias ", answers: ["7", "sete"], image: null },
      { id: "q10", question: "Que dia vem depois da quarta-feira?", answers: ["quinta-feira", "quinta"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "portuguese",
  name: "Vitoria",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bem-vindo ao questionário
Hospedado por Vitoria.

Você conhece os dias da semana?

Diga "Olá" a Vitória para começar.`,
  voice: "Vitoria",
  versionQuestion: "Quantas perguntas você gostaria neste modelo?",
};

export default quiz;
